import React from "react"
import MobilePreFooter from "../images/ace_rewards_prefooter_mobile.jpg"
import WebPreFooter from "../images/ace_rewards_prefooter.jpg"
import styled from "styled-components"

const Container = styled.div`
  display: flex;
  width: 100%;
`

const MobileView = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  @media (min-width: 768px) {
    display: none;
  }
`

const DesktopView = styled.div`
  display: none;
  @media (min-width: 768px) {
    display: flex;
    width: 100%;
    justifycontent: center;
  }
`

const ImageBox = styled.div`
  width: 100%;
`

const Image = styled.img`
  display: block;
  width: 100%;
`

const PreFooter = props => {
  return (
    <Container>
      <MobileView>
        <ImageBox>
          <Image src={MobilePreFooter} />
        </ImageBox>
      </MobileView>
      <DesktopView>
        <ImageBox>
          <Image src={WebPreFooter} />
        </ImageBox>
      </DesktopView>
    </Container>
  )
}

export default PreFooter
